<template>
  <div id="coll">
    <Breadcrumb></Breadcrumb>
    <div style="padding:0;" class="form-body">
      <div class="tab-pan">
        <div style="margin: 10px 0px;">
          <!--                    <div style="float: right;font-size: 13px;padding: 0px 10px 10px 0"><span>支持站点</span></div>-->
          <div class="url-div">
            <el-input
              v-if="false"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="singleUrl"
              style="border: black!important;"
              placeholder="请填写产品网址,多个网址使用Enter换行"
            ></el-input>
          </div>
          <div class="cj-tip">
            <div class="tip">
              <p>
                请使用采集插件，功能稳定快速。<a
                  target="_blank"
                  href="https://files.onecust.com/downloads/client/onecust.zip"
                  >插件下载</a
                ><span v-if="false">99</span>
              </p>
            </div>
            <div v-if="false" class="btn">
              <el-button size="small" type="primary" @click="collSingleData"
                >开始采集</el-button
              >
              <el-button size="small" plain @click="singleUrl = null"
                >清空</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-form
      :model="queryParams"
      ref="form"
      id="form"
      class="form-body"
      label-width="80px"
      style="margin-top: 10px"
    >
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="数据来源：">
              <el-select
                clearable
                v-model="queryParams.dataSource"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="(value, index) in dictData['plat_no']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="认领情况：">
              <el-select
                clearable
                v-model="queryParams.getFlag"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option label="是" value="1">是</el-option>
                <el-option label="否" value="0">否</el-option>
              </el-select>
            </el-form-item>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="产品名称：">
              <el-input
                size="small"
                v-model="queryParams.proName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="采集人员：">
              <el-input
                size="small"
                v-model="queryParams.operNo"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="8"
          ><div class="grid-content bg-purple">
            <el-form-item label="采集时间：">
              <el-date-picker
                size="small"
                v-model="queryParams.time"
                style="width: 100%;"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>

        <el-col :span="8"
          ><div class="grid-content bg-purple" style="text-align:right;">
            <el-button size="small" type="primary" @click="getList"
              >搜索</el-button
            >
            <el-button size="small" @click="resetForm">重置</el-button>
          </div></el-col
        >
      </el-row>
    </el-form>
    <div class="table-body">
      <div style="margin-top: 10px">
        <el-dropdown size="small" @command="claimToPlat_multi">
          <el-button size="small" type="primary">
            批量认领<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="01">「Amazon」采集箱</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          size="small"
          type="danger"
          style="margin-left: 10px"
          @click="batchDelete"
          :disabled="claimCollIds.length == 0"
          >一键删除</el-button
        >
        <el-button
          v-if="false"
          size="small"
          style="margin-left: 10px"
          @click="batchDelete"
          :disabled="claimCollIds.length == 0"
          >导出</el-button
        >
      </div>
      <div class="card-div">
        <div v-if="false" class="state-num-btn">
          <div class="state-btn" @click="loadByState($event)">
            全部 ({{ totalNum }})
          </div>
          <div class="state-btn select" @click="loadByState($event, 0)">
            未认领 ({{ unClaimed }})
          </div>
          <div class="state-btn" @click="loadByState($event, 1)">
            已认领 ({{ totalNum - unClaimed }})
          </div>
        </div>
        <el-table
          :data="tableData"
          :cell-class-name="setColumnClass"
          border
          class="clain-tab"
          header-cell-class-name="table-header"
          @selection-change="tableSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            label="产品信息"
            align="center"
            width="300"
            prop="image"
          >
            <template slot-scope="scope">
              <el-popover
                style="float:left;"
                placement="right"
                width="300"
                trigger="hover"
                :close-delay="closeDelay"
              >
                <img
                  class="img-big"
                  :src="scope.row.mainPic ? scope.row.mainPic : noImage"
                  style="width: 300px;height: 300px"
                />
                <img
                  slot="reference"
                  class="img-small"
                  :src="scope.row.mainPic ? scope.row.mainPic : noImage"
                />
                <div slot="reference">
                  来源：<a
                    style="text-decoration: none;color: #409eff"
                    :href="scope.row.dataUrl"
                    target="_blank"
                    >{{ foramtDataSource(scope.row.dataSource) }}</a
                  >
                </div>
              </el-popover>
              <div style="float:left;width:200px;">
                <a
                  target="_blank"
                  :href="scope.row.dataUrl"
                  style="color:#409eff;"
                  >{{ scope.row.proName }}</a
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="SKU"
            header-align="center"
            align="left"
            width="300"
            prop="proTitle"
          >
            <template slot-scope="scope">
              <div
                v-if="!scope.row.expand && index < 4"
                :title="`${record.properVal.replace(':', '-')}`"
                class="text-ellipsis"
                style="width:280px;"
                v-for="(record, index) in scope.row.skuList"
                :key="index"
              >
                {{ record.properVal.replace(":", "-") }}
              </div>
              <div
                v-if="scope.row.expand"
                :title="`${record.properVal.replace(':', '-')}`"
                class="text-ellipsis"
                style="width:280px;"
                v-for="(record, index) in scope.row.skuList"
                :key="index"
              >
                {{ record.properVal.replace(":", "-") }}
              </div>
              <div v-if="scope.row.skuList.length > 4">
                <span
                  @click="handleExpand(scope.row)"
                  style="color:#409eff;cursor:pointer;"
                  >{{ scope.row.expand ? "收起" : "展开" }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="价格"
            header-align="center"
            align="left"
            width="100"
            prop="simDesc"
          >
            <template slot-scope="scope">
              <div
                v-if="!scope.row.expand && index < 4"
                :title="`${record.properVal.replace(':', '-')}`"
                class="text-ellipsis"
                style="width:160px;"
                v-for="(record, index) in scope.row.skuList"
                :key="index"
              >
                ￥{{ record.price }}
              </div>
              <div
                v-if="scope.row.expand"
                :title="`${record.properVal.replace(':', '-')}`"
                class="text-ellipsis"
                style="width:160px;"
                v-for="(record, index) in scope.row.skuList"
                :key="index"
              >
                ￥{{ record.price }}
              </div>
              <div v-if="scope.row.skuList.length > 4">
                <span
                  @click="handleExpand(scope.row)"
                  style="color:#409eff;cursor:pointer;"
                  >{{ scope.row.expand ? "收起" : "展开" }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="库存"
            align="center"
            width="100"
            prop="priceUsd"
          >
            <template slot-scope="scope">
              <div
                v-if="!scope.row.expand && index < 4"
                class="text-ellipsis"
                v-for="(record, index) in scope.row.skuList"
                :key="index"
              >
                {{ record.quantity }}
              </div>
              <div
                v-if="scope.row.expand"
                class="text-ellipsis"
                v-for="(record, index) in scope.row.skuList"
                :key="index"
              >
                {{ record.quantity }}
              </div>
              <div v-if="scope.row.skuList.length > 4">
                <span
                  @click="handleExpand(scope.row)"
                  style="color:#409eff;cursor:pointer;"
                  >{{ scope.row.expand ? "收起" : "展开" }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="采集人员/时间"
            align="center"
            prop="creatorNo"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.operNo }}</div>
              <div>
                {{ parseTime(scope.row.collTime, "{y}-{m}-{d} {h}:{i}") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="认领记录"
            align="center"
            prop="claimRecord"
            :formatter="formatTake"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.getFlag !== '0'">
                已认领到{{ scope.row.getFlag }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop="hand"
            width="100"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                @click="handleCollAmazon(scope.row)"
                class="el-dropdown-link"
                style="color: #409EFF !important;font-size: 12px !important;cursor:pointer;"
              >
                认领到亚马逊
              </span>
              <br />
              <el-button type="text" size="small" @click="editRow(scope.row)"
                >编辑</el-button
              ><br />
              <el-button
                type="text"
                size="small"
                @click="deleteRow(scope.row.collId)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="添加备注"
      width="35%"
      :visible.sync="noteDialogVisible"
      class="note-dialog"
    >
      <el-row style="display: flex;align-items: center">
        <el-col :span="2">
          <p>内容:</p>
        </el-col>
        <el-col :span="22">
          <el-input
            placeholder="请输入介绍信息"
            type="textarea"
            :rows="10"
            v-model="noteContent"
          ></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noteDialogVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitAddNote" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--认领弹出框-->
    <el-dialog
      :close-on-click-modal="false"
      title="店铺"
      :visible.sync="claimDialogVisible"
      width="50%"
      class="claim_Title"
    >
      <el-checkbox-group
        v-model="checkedList"
        style="display: flex;margin: 15px 20px 7px"
      >
        <el-row
          v-for="(item, index) in claimList"
          :key="index"
          style="margin-left: 15px"
        >
          <el-checkbox :label="item.shopId">{{ item.shopName }}</el-checkbox>
        </el-row>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="claim" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="商品采集"
      width="35%"
      :visible.sync="collResultVisible"
    >
      <div style="min-height: 100px">
        <div
          style="padding: 10px 20px 0px;font-size: 16px;color: green;font-weight: bold"
        >
          <span>采集任务完成</span>
        </div>
        <div style="padding: 10px 30px 0px;font-size: 14px;">
          成功 <span style="color:green">{{ collResult.success }}</span> 个
        </div>
        <div
          v-if="collResult.error > 0"
          style="padding: 10px 30px 0px;font-size: 14px;"
        >
          失败 <span style="color: red">{{ collResult.error }}</span> 个
        </div>
        <div v-if="collResult.error > 0" style="padding: 10px 20px;">
          <div>采集失败URL:</div>
          <el-row
            style="margin: 10px"
            v-for="url in collResult.errorUrl.split(',')"
          >
            <span>{{ url }}</span>
          </el-row>
        </div>
      </div>
      <div solt="footer" style="padding: 0px 20px 20px;text-align: right">
        <el-button size="small" type="primary" @click="continueColl"
          >继续采集</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  loadData,
  updateColl,
  deleteData,
  deleteById,
  getShopByPlatCode,
  claimToPlat,
  manageList,
  getTotalAndUnClaimedNum,
} from "@/api/product/common"

import { getCollList, getColl, deleteColl, startColl } from "@/api/product/coll"
import { encrypt, decrypt } from "@/utils/jsencrypt"
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import TreeSelect from "@/components/common/treeSelect"
import noImage from "@/assets/images/no_image.png"

export default {
  name: "CollectionBox",
  components: { Breadcrumb, TreeSelect },
  data() {
    return {
      // 遮罩层
      loading: true,
      closeOnClickModal: false,
      closeDelay: 0,
      total: 0,
      singleUrl: null, //单品采集URL
      managerList: [], //责任人集合
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        dataSource: "", //数据来源
        beginTime: null,
        endTime: null,
        time: [],
        getFlag: "",
        proName: "",
        operNo: "",
      },
      dataSource: "all",
      searchType: "1",
      collTime: "",
      date2: "",
      showMoreItem: false,
      showDatePicker: false,
      tableData: [],
      noteDialogVisible: false, //备注弹框
      currentRow: null, //当前编辑行
      noteContent: null, //备注
      claimDialogVisible: false, //认领弹框
      claimList: [], //平台店铺的List
      claimCollIds: [], ////选中 的产品id
      checkedList: [], //店铺选中List
      rowData: null, //认领的产品行数据
      takePlat: null, //认领的类型
      platformCodes: [], //平台字典数据
      claimType: "",
      collResultVisible: false,
      collResult: {
        success: undefined,
        error: undefined,
        errorUrl: undefined,
      },
      totalNum: 0,
      unClaimed: 0,
      form: {
        pageNum: 1,
        pageSize: 10,
        typeId: "",
        proName: "",
        productType: "",
        beginTime: null,
        endTime: null,
        prodDays: "",
        dzStatus: "",
        pId: "",
        basicId: "",
      },
      noImage: noImage,
    }
  },
  computed: {
    rowSelectNum() {
      return this.claimCollIds.length
    },
    userName() {
      return this.$store.state.user.name
    },
    primAcc() {
      return this.$store.state.user.primAcc
    },
    isMain() {
      return this.userName == this.primAcc
    },
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.queryParams.time = [this.parseTime(preDate, "{y}-{m}-{d}") , this.parseTime(curDate,"{y}-{m}-{d}")]
    this.getDicts("s_plat_code").then((response) => {
      this.platformCodes = response.data
      this.getList()
    })
    this.getAllUser()
    this.loadStateNum()
  },
  methods: {
    collSingleData() {
      const newUrl = this.singleUrl
        .trim()
        .replace(/\r\n/g, ",")
        .replace(/\r/g, ",")
        .replace(/\n/g, ",")
      const loading = this.$loading({
        lock: true,
        text: "商品采集中，请稍后……",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      startColl({ dataUrl: newUrl })
        .then((res) => {
          if (res.code == 200) {
            loading.close()
            this.singleUrl = ""
            this.msgSuccess("采集任务添加成功，请稍后刷新列表")
            window.setTimeout(() => {
              this.getList()
            }, 3000)
          }
        })
        .catch((err) => {
          loading.close()
        })
    },
    async handleCollAmazon(row) {
      let result = await getColl({ collId: row.collId })
      this.getList()
      this.$message.success("认领成功")
    },
    getList() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]

      getCollList(params)
        .then((res) => {
          res.rows.map((record) => {
            record.expand = false
          })
          this.tableData = res.rows
          this.total = res.total
          this.endLoading()
        })
        .catch((err) => {
          this.endLoading()
          console.log(err)
        })
    },
    handleExpand(row) {
      row.expand = !row.expand
    },
    loadByState(e, val) {
      let _dom = document.querySelector(".card-div .state-num-btn .select")
      if (_dom) {
        _dom.classList.toggle("select") //当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
      }
      e.target.classList.toggle("select")
      this.queryParams.takePlat = val
      this.getList()
    },
    setClassManage: function() {
      this.classManageDialog = true
    },
    closeCMDialog_f: function() {
      this.classManageDialog = false
    },
    show: function() {},
    //获取所有当前用户相关联的账号（主账号和其子账号）
    getAllUser() {
      manageList().then((res) => {
        this.managerList = res.data
      })
    },
    search: function() {
      this.form.searchStr = "45649"
      alert("查询")
    },
    //批量删除
    batchDelete: function() {
      if (this.claimCollIds.length == 0) {
        this.$message.warning("至少选择一个要删除的商品！")
        return false
      }
      this.$confirm("确定要删除选中的商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await deleteColl(this.claimCollIds.join(","))
          this.getList()
          this.msgSuccess("删除成功")
        })
        .catch(() => {})
    },
    //搜索类型切换
    searchTypeChange(val) {
      if (val == "1") {
        this.queryParams.searchType = "pro_title"
      } else if (val == "2") {
        this.queryParams.searchType = "data_url"
      }
    },
    //找货源
    searchProductSource(url) {
      window.open("https://kj.1688.com/pdt_tongkuan.html?imgUrl=" + url)
    },
    setColumnClass(row, column, rowIndex, columnIndex) {
      if (row.column.label === "描述") {
        return "list-simDesc"
      }
    },
    //认领状态切换
    takePlatChange(val) {
      this.getList()
    },
    //表格认领字段格式化
    formatTake(val) {
      let temp = this.platformCodes.filter((item) => {
        return val.takePlat == item.dictValue
      })
      if (temp.length > 0) {
        return temp[0].dictLabel
      }
    },
    dateChange(val) {
      this.queryParams.startTime = this.parseTime(
        val[0],
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
      this.queryParams.endTime = this.parseTime(
        val[1],
        "{y}-{m}-{d} {h}:{i}:{s}"
      )
      this.getList()
    },
    tableSelectionChange(val) {
      this.claimCollIds = []
      val.forEach((r) => {
        this.claimCollIds.push(r.collId)
      })
    },
    //编辑产品
    editRow(row) {
      this.$router.push({
        path: "/product/amazon/createProduct",
        query: { collId: row.collId, type: "1" },
      })
    },
    //添加备注
    addNote(row) {
      this.noteDialogVisible = true
      this.noteContent = row.remark
      this.currentRow = row
    },
    //删除产品（单个删除）
    deleteRow(id) {
      this.$confirm("确定要删除选中的商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteColl(id).then((res) => {
            if (res.code == 200) {
              this.getList()
              this.loadStateNum()
              this.msgSuccess("删除成功")
            }
          })
        })
        .catch(() => {})
    },
    submitAddNote() {
      console.log(this.noteContent)
      this.currentRow.remark = this.noteContent
      updateColl(this.currentRow)
        .then((res) => {
          if (res.code === 200) {
            this.getList()
          }
        })
        .catch(() => {})
      this.noteDialogVisible = false
    },
    foramtDataSource(val) {
      if (val == "01") {
        return "1688"
      } else if (val == "02") {
        return "速卖通"
      } else if (val == "03") {
        return "Lazada"
      } else if (val == "04") {
        return "Amazon"
      } else if (val == "05") {
        return "Shopee"
      } else if (val == "06") {
        return "淘宝"
      } else if (val == "07") {
        return "京东"
      }
      return "未知"
    },
    //认领到平台
    claimToPlat_single(val) {
      this.claimType = "single" //单个产品认领
      this.checkedList = []
      this.rowData = val.row
      this.takePlat = val.command
      this.claimDialogVisible = true
      getShopByPlatCode(val.command).then((res) => {
        this.claimList = res.data
      })
    },
    //
    async claimToPlat_multi(val) {
      if (!this.claimCollIds.length > 0) {
        this.msgError("请先勾选需要认领的产品！")
        return false
      }
      if (val === "01") {
        await getColl({ collId: this.claimCollIds.join(",") })
        this.getList()
      }
    },
    //command处理前的数据
    beforeHandleCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command,
      }
    },
    //认领确定方法
    claim() {
      if (this.checkedList.length == 0) {
        this.msgError("至少选择一间店铺")
        return
      }
      let params = {}
      if (this.claimType == "single") {
        params = {
          row: this.rowData,
          shopList: this.checkedList,
          takePlat: this.takePlat,
          collIds: [this.rowData.collId],
        }
      } else if (this.claimType == "multi") {
        params = {
          row: this.rowData,
          shopList: this.checkedList,
          takePlat: this.takePlat,
          collIds: this.claimCollIds,
        }
      }
      claimToPlat(params).then((res) => {
        if (res.code == 200) {
          this.msgSuccess("认领成功")
          this.loadStateNum()
          this.getList()
          this.claimDialogVisible = false
        }
      })
    },
    //继续采集
    continueColl() {
      this.singleUrl = null
      this.collResultVisible = false
    },
    loadStateNum() {
      getTotalAndUnClaimedNum()
        .then((res) => {
          this.totalNum = res.data.total
          this.unClaimed = res.data.unClaimed
        })
        .catch((err) => {})
    },
    resetForm() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        dataSource: "", //数据来源
        beginTime: null,
        endTime: null,
        time: [],
        getFlag: "",
        proName: "",
        operNo: "",
      }
    },
  },
  mounted() {
 
  },
}
</script>

<style scoped>
@import "../../../assets/css/comFu.css";
.el-table__row {
  font-size: 13px;
}
</style>
